import React, { useMemo } from 'react';

import { Container, Bar } from './styles';

const ProgressBar = ({ numberOfSteps, stepIndex }) => {
    const calculateProgress = useMemo(() => {
        return Math.floor((stepIndex / numberOfSteps) * 100);
    }, [stepIndex, numberOfSteps]);

    return (
        <Container>
            <Bar width={calculateProgress} />
        </Container>
    );
};

export default ProgressBar;
